import COLORS from "./Colors";

export const ROLE_CONFIG_KEYS = {
  graniteAnalytics: "GraniteAnalytics",
  graniteSettings: "UserSettings",
  Cutter: "Cutter",
  wiresaw: "Wiresaw",
  cart: "Cart",
  customers: "Customers",
  groups: "Groups",
  inventory: "Inventory",
  yard: "Yard",
  sale: "Sale",
  graniteStoreInventory: "StoreInventory",
  graniteCostAnalysis: "CostAnalysis",
  broadcasts: "Broadcasts",
  quotations: "Quotation",
  notifications: "Notifications",
  order: "Order",
  outstanding: "Outstanding",
  payment: "Payment",
  preferences: "Preferences",
  profile: "Profile",
  representatives: "Representatives",
  return: "Return",
  specialOffers: "Special Offers",
  suppliers: "Suppliers",
  user: "User",
  invoices: "Invoices",
  coupons: "Coupons",
  roleSwitch: "Role_Switch",
  subUserLogin: "Sub_User_Login",
  modeSwitch: "Mode_Switch",
  subscriptions: "Subscriptions",
  creditNote: "Credit_Notes",
  settings: "Settings",
  tracking: "Tracking",
  logistics: "Logistics",
  product: "Product",
  bulkOrder: "BulkOrder",
  Erp_Dashboard: "Erp_Dashboard",
  Erp_Users: "Erp_Users",
  Slab: "Slab",
  History: "History",
  home: "Home",
  // RMPM Features

  goods: "Goods",
  createUser: "Create_User",
  productInfo: "ProductInfo",
  scm: "SCM",
  scmProduct: "Scm Product",
  rmpmSale: "RMPMSale",
  scmPo: "SCMPurchaseOrder",
  productMapping: "product_mapping",
  grn: "GRN",

  reports: "Reports",
  din: "Din",
  dinData: "DinData",
  grnQc: "GRNQC",
  reservation: "Reservation",
  borrowRequest: "BorrowRequest",
  ledger: "Ledger",
  salesReports: "SalesReports",
  masterReports: "MasterReports",
  treasuryAnalytics: "TreasuryAnalytics",
  saleAnalytics: "SaleAnalytics",
  inventoryAnalytics: "InventoryAnalytics",
  rmpmSaleQuotation: "RmpmSaleQuotation"
};

export const FETCH_MODE = {
  supplier: "supplier",
  customer: "customer"
};

export const CURRENT_MODE = {
  sale: "Sale",
  purchase: "Purchase"
};

export const DATE_FORMAT = {
  standard_dmy: "DD/MM/YYYY",
  hyphen_ymd: "YYYY-MM-DD",
  dmy_with_time: "DD/MM/YYYY hh:mm a",
  dmy_with_comma: "DD MMM, YY",
  standard_dmy_with_time: "Do MMMM YYYY, h:mm a"
};

export const ORDER_TYPE = {
  return: "Return",
  sale: "Sale"
};

export const PERMISSIONS = {
  read: "Read",
  create: "Create",
  select: "Select",
  delete: "Delete",
  update: "Update"
};

export const PAYMENT_TYPE = {
  offline: "OFFLINE",
  online: "ONLINE"
};

export const PAYMENT_STATUS = {
  pending: "Pending",
  processing: "Processing"
};

export const ROLE = {
  salesman: "ROLE_SALESMAN",
  distributor: "ROLE_DISTRIBUTOR",
  retailer: "ROLE_RETAILER",
  retailerSingleDistributor: "ROLE_RETAILER_SINGLE_DISTRIB",
  groupAdmin: "ROLE_ADMIN_GROUP",
  marketingRep: "ROLE_MARKETING_REP",
  manufacturer: "ROLE_MANUFACTURER",
  analytics: "ROLE_ANALYTICS",
  erp: "ROLE_ERP"
};

export const GRANITE_ROLE = {
  user: "ROLE_USER",
  subUser: "ROLE_SUBUSER"
};

export const RMPM_ROLE = {
  superAdmin: "ROLE_SUPER_ADMIN",
  packingHead: "ROLE_PACKING_HEAD",
  storeHead: "ROLE_STORE_HEAD",
  productionHead: "ROLE_PRODUCTION_HEAD",
  packingAdmin: "ROLE_PACKING_ADMIN",
  storeAdmin: "ROLE_STORE_ADMIN",
  productionAdmin: "ROLE_PRODUCTION_ADMIN",
  packingLocationHead: "ROLE_PACKING_LOCATION_HEAD",
  storeLocationHead: "ROLE_STORE_LOCATION_HEAD",
  productionLocationHead: "ROLE_PRODUCTION_LOCATION_HEAD",
  packingManager: "ROLE_PACKING_MANAGER",
  processManager: "ROLE_PROCESS_MANAGER",
  rAndD: "ROLE_RANDD",
  qC: "ROLE_QC",
  scm: "ROLE_SCM",
  sale: "ROLE_SALE",
  salesHead: "ROLE_SALES_HEAD",
  masterAdmin: "ROLE_MASTER_ADMIN"
};

export const REQUEST_STATUS = {
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  DECLINED: "DECLINED",
  BLOCKED: "BLOCKED"
};

export const ORDER_STATUS = {
  cancelled: "CANCELLED",
  delivered: "DELIVERED",
  invoiced: "INVOICED",
  processing: "PROCESSING",
  received: "RECEIVED"
};

export const INVOICE_STATUS = {
  delivered: "DELIVERED",
  dispatched: "DISPATCHED"
};

export const USER_MODE = {
  READ: "read",
  EDIT: "edit"
};

export const QUOTATION_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  DEACTIVATED: "De-activated",
  PENDING: "PENDING"
};

export const QUOTATION_UPDATES = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  DETAILS: "Details",
  DEACTIVATE: "De-activate"
};
export const approvalActionsMappings = {
  APPROVED: { title: "Approve", color: COLORS.action_approve },
  DECLINED: { title: "Decline", color: COLORS.action_decline },
  REVIEW: { title: "Review", color: COLORS.action_review }
};

export const NOTIFICATION_TYPE = {
  order: "ORDER",
  offer: "OFFER",
  coupon: "COUPON",
  quotation: "QUOTATION",
  newDistributor: "NEW_DISTRIBUTOR",
  payment: "PAYMENT",
  creditNote: "CREDIT_NOTE",
  invoice: "INVOICE",
  associationRequest: "ASSOCIATION_REQUEST"
};

export const BOOLEAN_ACTION = {
  yes: "Yes",
  no: "No"
};

export const ORDER_STATUS_ID = {
  received: 1,
  processing: 2,
  cancelled: 3
};

export const ORDER_ACTION = {
  dispatch: 3,
  cancel: 4
};

export const BATCH_SIZE = {
  size: 5
};

export const PAGE_SIZE_OPTIONS = ["10", "20", "30", "40", "50"];

export const supportNumber = "+91 9347236212";

export const ORDER_ACTIONS_LIST = {
  PRINT: "print",
  INVOICE: "invoice",
  DISPATCH: "dispatch",
  CANCEL: "cancel",
  DELIVER: "deliver",
  REINVOICE: "re-invoice"
};
